// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lZPV7","titleStyle":"styles_titleStyle__AnjC2"};